import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";

import api from "@/services/api";
import useStore from "@/services/store";
import { useComponentTranslation } from "@/services/i18n";

import JobLayout from "./job-layout";

const translations = {
  en: { fetch_error: "Error fetching job" },
  fr: { fetch_error: "Erreur lors de la récupération du poste" },
};

export default function View() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [job, setJob] = useState(null);
  const [posts, setPosts] = useState([]);
  const { t } = useComponentTranslation(translations);
  const { setEntity, clearEntity } = useStore();

  useEffect(() => {
    loadData();
    return () => clearEntity("job");
  }, [id]);

  const loadData = async () => {
    try {
      setLoading(true);
      const jobResponse = await api.get(`/job/${id}`);
      if (!jobResponse.ok) {
        navigate("/recruiter/job-ads", { replace: true });
        return toast.error(jobResponse.code);
      }
      setJob(jobResponse.data);
      setEntity("job", jobResponse.data);

      const postsResponse = await api.post("/post/search", { job_id: id, limit: 100 });
      if (postsResponse.ok) setPosts(postsResponse.data || []);
    } catch (e) {
      console.error("Error loading data:", e);
      toast.error(e.code);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !job) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 md:h-12 md:w-12 border-2 border-y-primary border-x-transparent" />
      </div>
    );
  }

  return <JobLayout job={job} setJob={setJob} posts={posts} setPosts={setPosts} />;
}
